import { inject, Injectable } from '@angular/core';
import { _, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ClipboardCopyService } from '@app/core/services/clipboard-copy/clipboard-copy.service';
import { IMainTableCellContext } from '@app/main/main-content/main-table/interfaces/main-table-cell-context.interface';

@Injectable({ providedIn: 'root' })
export class ContextMenuCopyService {
  private readonly translateService = inject(TranslateService);
  private readonly clipboardCopy = inject(ClipboardCopyService);

  public getCopyCellItems(cell: IMainTableCellContext | undefined): MenuItem[] {
    const value = cell?.value;

    if (value === undefined || value === null || value === '') return [];

    return [
      {
        label: this.translateService.instant(_(`@@shared-tooltip-copy-to-clipboard__text`)),
        icon: 'icons/icon-copy-big.svg',
        command: () => this.clipboardCopy.copy(value),
      },
      { separator: true },
    ];
  }
}
